export function localizedNumber(amount) {
    return amount !== null ? Number((+amount).toFixed(2)) : null
}

export function localizedAmount(amount, currency, options = {}) {
    const { maximumFractionDigits = 2 } = options;
    return Intl.NumberFormat(navigator.language || 'zh-TW', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits,
        minimumFractionDigits: 0
    }).format(amount);
}

export function getCurrencySymbol(currency) {
    const formatted = Intl.NumberFormat(navigator.language || 'zh-TW', {
        style: 'currency',
        currency
    }).format(0);
    const symbol = formatted.replace(/[\d\s,.]/g, '');
    return symbol;
}